export const AUTO_SELL_FORM_CHANGE = 'AUTO_SELL_FORM_CHANGE'
export const AUTO_BUY_FORM_CHANGE = 'AUTO_BUY_FORM_CHANGE'
